import Sidebar from './Sidebar/Sidebar';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import HomeAlerts from './HomeAlerts';

const ContentWrapper = styled.div`
  display: flex;
`;

const Layout = () => {
  return (
    <div className="main-wrapper">
      <Header admin />
      <ContentWrapper>
        <Sidebar />
        <div className={'main-content position-relative'}>
          <HomeAlerts />
          <div className="content">
            <Outlet />
          </div>
          <Footer />
        </div>
      </ContentWrapper>
    </div>
  );
};

export default Layout;
